/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PptSchemaService {

    /**
     * @param schemaIdentifier 
     * @returns any OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppPptSchema(
schemaIdentifier: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/ppt-schema/{schemaIdentifier}',
            path: {
                'schemaIdentifier': schemaIdentifier,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
